<template>
  <CodeColorIndicator
    v-if="feedCodes.length || isCompact"
    codeType="feeds"
    :codes="feedCodes"
    :maxItems="props.isCompact ? 2 : 4"
    :isCompact="props.isCompact"
    data-test-selector="code-indicator-line"
  />
  <CodeColorIndicator
    v-if="nonFeedCodes.length || isCompact"
    codeType="non-feeds"
    :codes="nonFeedCodes"
    :maxItems="props.isCompact ? 2 : 3"
    :isCompact="props.isCompact"
    data-test-selector="code-indicator-circle"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CodeColorIndicator from './CodeColorIndicator.vue'
import { useCodesStore } from '@/ContextTab/stores/codes'
import { isFeedAndPubCode } from '@/lib/codes'
import type { CodeWithCategory } from '@/api/generated/v2'


const props = defineProps<{
  codes: CodeWithCategory[]
  isCompact: boolean
}>()

const codesStore = useCodesStore()

const feedCodes = computed(() => props.codes
  .filter((code) => isFeedAndPubCode(code) && codesStore.codeColorsMap[code.id]),
)

const nonFeedCodes = computed(() => props.codes
  .filter((code) => !isFeedAndPubCode(code) && codesStore.codeColorsMap[code.id]),
)
</script>

<style scoped></style>
